<!-- 订单列表 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div>
        <el-radio-group
          v-model="orderType"
          class="order-type-box"
          @input="orderTypeChange"
        >
          <el-radio-button class="order-type-item" label="1"
            >机构开通订单</el-radio-button
          >
          <el-radio-button
            class="order-type-item"
            label="2"
            v-if="role == 'admin'"
            >学员自购订单（推广订单）</el-radio-button
          >
          <el-radio-button
            v-if="is_study_card"
            class="order-type-item"
            label="3"
            >卡密订单</el-radio-button
          > 
        </el-radio-group>
      </div>
      <div class="querySearch">
        <div class="searchItem">
          <span>订单号</span>
          <el-input
            v-model="queryInfo.order_no"
            clearable
            size="small"
            placeholder="请输入订单号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>学员账号</span>
          <el-input
            v-model="queryInfo.user_no"
            clearable
            size="small"
            placeholder="请输入学员账号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>学员姓名</span>
          <el-input
            v-model="queryInfo.user_name"
            clearable
            size="small"
            placeholder="请输入学员姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>学员手机号</span>
          <el-input
            v-model="queryInfo.user_mobile"
            clearable
            size="small"
            placeholder="请输入学员手机号"
          ></el-input>
        </div>
        <div class="searchItem" v-if="orderType == 2">
          <span>收益类型</span>
          <el-select
            v-model="queryInfoSelf.income_type"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="searchItem" v-if="orderType == 2">
          <span>推广者姓名</span>
          <el-autocomplete
            class="inline-input"
            v-model="queryInfoSelf.promoter_fullname"
            :fetch-suggestions="querySearch"
            placeholder="可模糊查询和下拉查询"
            clearable
            @select="handleNameSelect"
          ></el-autocomplete>
        </div>
        <div class="searchItem" v-if="orderType == 1">
          <span>开通人</span>
          <el-input
            v-model="queryInfo.pm_user_id"
            clearable
            size="small"
            placeholder="请输入开通人"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>商品类型</span>
          <el-select
            v-model="queryInfo.good_type"
            size="small"
            class="w100Select"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in userTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>商品名称</span>
          <el-input
            v-model="queryInfo.good_name"
            clearable
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>商品ID</span>
          <el-input
            v-model="queryInfo.good_id"
            clearable
            size="small"
            placeholder="请输入商品ID"
          ></el-input>
        </div>

        <div class="searchItem">
          <span>订单状态</span>
          <el-select
            v-if="orderType == 1"
            v-model="queryInfo.pay_status"
            size="small"
            class="w100Select"
            @change="payStatusChange"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
            <el-option label="已开通" :value="0"></el-option>
            <el-option label="已扣款" :value="1"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
          <el-select
            v-else-if="orderType == 2"
            v-model="queryInfo.pay_status"
            size="small"
            class="w100Select"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
            <el-option label="未支付" :value="6"></el-option>
            <el-option label="已支付" :value="7"></el-option>
          </el-select>
          <el-select
            v-else
            v-model="queryInfo.pay_status"
            size="small"
            class="w100Select"
          >
            <el-option
              v-for="item in order_status_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="searchItem">
          <el-select
            v-model="timeChange"
            size="small"
            class="w100Select"
            @change="timeChangeClick"
          >
            <el-option label="支付时间" :value="4"></el-option>
            <el-option label="创建时间" :value="2"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            @change="selectData"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <div v-if="subjectOptions.length > 1" class="searchItem">
          <span>所属考试</span>
          <el-select
            v-model="subject_cate_ids"
            size="small"
            clearable
            multiple
            collapse-tags
            placeholder="请选择所属考试"
          >
            <el-option
              v-for="item in subjectOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </div>

        <div v-if="orderType == 3" class="searchItem">
          <span>开卡状态</span>
          <el-select
            v-model="queryInfo.card_status"
            size="small"
            class="w100Select"
          >
            <el-option
              v-for="item in card_status_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <!-- <el-select
          v-model="queryInfo.card_status"
          size="small"
          class="w100Select"
          filterable
          clearable
        > 
          <el-option label="全部" :value="0"></el-option>
          <el-option label="已开卡" :value="1"></el-option>
          <el-option label="未开卡" :value="2"></el-option>
          <el-option label="已失效" :value="3"></el-option>
        </el-select> -->
        </div>
        <div class="searchItem" v-if="orderType == 1">
          <span>学员所属创建人</span>
          <el-select
            style="width: 220px"
            v-model="create_user"
            filterable
            placeholder="请输入学员所属创建人"
            multiple
            collapse-tags
            remote
            reserve-keyword
            :remote-method="debounce(getTobSearchCreateUser, 500)"
            @clear="createUserOptions = []"
            clearable
          >
            <el-option
              v-for="item in createUserOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-btn-box">
          <!-- <el-button type="primary" size="small" @click="queryTable('search')"
          >搜索</el-button
        >
        <el-button type="warning" size="small" @click="resetQuery"
          >重置</el-button
        > -->
          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>

          <MyButton
            v-if="role == 'admin' || role == 'generaladministrato'"
            value="导出订单列表"
            size="medium"
            type="3"
            @click="downloadOrderList"
          ></MyButton>

          <!-- <el-button
            v-if="orderType == 2"
            type="danger"
            size="small"
            @click="downloadExcel"
            :loading="downExcelLoading"
            >导出Excel</el-button
          > -->
        </div>
      </div>
      <!-- <div class="addInfo">
        <el-button type="success" size="small" @click="viewDetail">导出excel</el-button>
        <el-button type="success" size="small" @click="viewDetail">导出统计excel</el-button>
      </div> -->
      <div class="table" v-loading="tableLoading">
        <TableComponents
          v-if="orderType == 1"
          :columns="columns"
          :tableData="tableList"
          :tableFunction="tableFunction"
          :allSelectedStatus="allSelectedStatus"
          :allStatus="allStatus"
          :selectableShow = "selectableShow"
          @choiceGoods="choiceGoods" 
        >
          <template slot="good_name" slot-scope="{ row }">
            {{ row.good_name }}
            <span style="color: red;" v-if="row.upgrade_from_good_name">{{ row.upgrade_from_good_name}}</span>
          </template>
          <template slot="fees" slot-scope="{ row }">
            {{ row.fees }}
            <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
          </template>
          <template slot="create_user" slot-scope="{ row }">
            <div v-if="row.userext">
              {{ row.userext.create_user }} 
            </div>
          </template>
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewDetail(row, 1)">查看详情</span>
            <span v-if="row.is_upgrade == 1">已升级</span>
            <span style="color: orange; cursor: pointer;" v-else-if="row.is_can_upgrade == 1" @click="upgradeOrder(row)">升级</span>
          </template>
        </TableComponents>
        <TableComponents
          v-if="orderType == 2"
          :columns="selfColumns"
          :tableData="tableList"
          :tableFunction="tableFunction"
          :allSelectedStatus="allSelectedStatus"
          :allStatus="allStatus"
          :selectableShow = "selectableShow"
          @choiceGoods="choiceGoods"
        >
          <template slot="fees" slot-scope="{ row }">
            {{ row.fees }}
            <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
          </template>
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewDetail(row, 1)"
              >查看详情</span
            >
          </template>
        </TableComponents>
        <TableComponents
          v-if="is_study_card && orderType == 3"
          :columns="kamilColumns"
          :tableData="tableList"
          :tableFunction="tableFunction"
          :allSelectedStatus="allSelectedStatus"
          :allStatus="allStatus"
          :selectableShow = "selectableShow"
          @choiceGoods="choiceGoods"
        > 
          <template slot="good_name" slot-scope="{ row }">
            {{ row.good_name }}
            <span style="color: red;" v-if="row.upgrade_from_good_name">{{ row.upgrade_from_good_name}}</span>
          </template>
          <template slot="fees" slot-scope="{ row }">
            {{ row.fees }}
            <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
          </template>
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewDetail(row, 1)"
              >查看详情</span
            >
            <span v-if="row.is_upgrade == 1">已升级</span>
            <span style="color: orange; cursor: pointer;" v-else-if="row.is_can_upgrade == 1" @click="upgradeOrder(row)">升级</span>
          </template>
        </TableComponents>
      </div>
      <div style="padding: 10px 20px 0 20px;display: flex;justify-content: space-between;align-items: center;">
        <div v-if="queryInfo.pay_status==0 && can_view_amount == 1">
          <el-checkbox
            v-model="allSelectedStatus"
            @change="allSelected"
            style="margin-right: 20px;"
            >当前页</el-checkbox>
          <el-checkbox
            v-model="allStatus"  
            @change="allStatusChange"
            style="margin-right: 20px;"
            > 
              {{ allStatusText }}
          </el-checkbox>

          <el-button type="text" @click="cancelOrderFn()">批量取消订单</el-button>
        </div> 
        <div v-else></div>
        <h5>
          总订单<span style="color: red;">{{ queryInfo.total }}</span>
          条、已支付订单<span style="color: red;">{{ allInfo.pay_count }}</span>条
          <!-- 高级管理员,普通管理员显示 -->
          <span v-if="can_view_amount == 1" >
          、实付总金额<span style="color: red;">{{ allInfo.pay_fee }}</span
          >元、总退款金额<span style="color: red;">{{ allInfo.refund_fee }}</span
          >元</span>
        </h5>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      @close="detailDialogCancel"
      class="formDialog"
      width="500px"
    >
      <div>
        <div class="orderD" v-if="!userCustomShow">
          <span>订单号：</span>
          <div>{{ userInfo.order_no }}</div>
        </div>
        <!-- <div class="orderD" v-if="!userCustomShow">
          <span>所属机构：</span>
          <div>{{ userInfo.order_no }}</div>
        </div> -->
        <div class="orderD" v-if="!userCustomShow">
          <span>开通人：</span>
          <div v-if="orderType < 3">{{ userInfo.qgroup.name }}</div>
          <div v-else>{{ userInfo.group_name }}</div>
        </div>
        <div class="orderD">
          <span>商品名称：</span>
          <div>{{ userInfo.good_name }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>订单总价：</span>
          <div>{{ userInfo.fee }}</div>
        </div> 
        <div class="orderD">
          <span>实付金额：</span>
          <div>{{ userInfo.fees }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>创建时间：</span>
          <div>{{ userInfo.created_at }}</div>
        </div>
        <div
          class="orderD"
          v-if="!userCustomShow && orderType == 3 && userInfo.pay_at"
        >
          <span>支付时间：</span>
          <div v-if="userInfo.order_type == 1">
            {{ userInfo.pay_at ? userInfo.pay_at : "待激活" }}
          </div>
          <div v-else-if="userInfo.order_type == 2">
            {{ userInfo.pay_at ? userInfo.pay_at : "未支付" }}
          </div>
          <div v-if="orderType == 3">
            {{ userInfo.pay_at }}
          </div>
        </div>
        <div
          class="orderD"
          v-if="userInfo.pay_at && !userCustomShow && userInfo.expire_at"
        >
          <span>到期时间：</span>
          <div>{{ userInfo.expire_at }}</div>
        </div>
        <div class="orderD" v-if="userCustomShow">
          <span>退费时效：</span>
          <span>{{ userInfo.qorder_prescription }}</span>
        </div>
        <!-- <div class="orderD" v-if="!userCustomShow">
            <span>备注：</span>
            <el-input type="textarea" v-model="userInfo.remarks"></el-input>
          </div> -->
        <div class="orderD" v-if="userCustomShow">
          <span>退款原因备注：</span>
          <el-input
            v-model="userInfo.remarksTuifei"
            maxlength="50"
            show-word-limit
            type="textarea"
            style="width: 250px"
            placeholder="请输入退款原因"
          ></el-input>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!userCustomShow">
          <el-button v-if="userInfo.pay_status == 5" size="mini" type="info"
            >退费失败</el-button
          >
          <el-button
            :type="userInfo.is_can_refund == 1 || userInfo.is_can_cancel == 1 ? 'warning' : 'info'"
            @click="cancelOper"
            size="mini"
            v-if="!isSalespersonr"
            style="margin: 0 10px"
            >{{ payTypeOrderName }}</el-button
          >  
          <div v-if="this.orderType == 3" style="display: inline-block">
            <div
              v-if="!this.userInfo.is_can_refund && !!this.userInfo.tobrefund"
              style="display: none"
            ></div>
            <el-button v-else @click="addFormShow = false" size="mini"
              >关闭</el-button
            >
          </div>
          <div v-else style="display: inline-block">
            <el-button
              v-if="
                userInfo.pay_status !== 3 &&
                userInfo.pay_status !== 4 &&
                userInfo.pay_status !== 5 &&
                !isSalespersonr
              "
              @click="addFormShow = false"
              size="mini"
              >关闭</el-button
            >
          </div>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button type="primary" @click="tuifeiAdd" size="mini"
            >提交申请</el-button
          >
          <el-button @click="userCustomShow = false" size="mini"
            >关闭</el-button
          >
        </div>
        <div
          style="
            text-align: center;
            margin-top: 20px;
            color: #66b1ff;
            cursor: pointer;
          "
          v-if="
            userInfo.pay_status == 3 ||
            userInfo.pay_status == 5 ||
            (this.orderType == 3 &&
              !this.userInfo.is_can_refund &&
              !!this.userInfo.tobrefund)
          "
          @click="skipToTuikuan"
        >
          查看详情
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>

    
    <el-dialog
      title=""
      :visible.sync="allStatusVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        已选择 
        <span v-if="allStatus" style="color:red">{{ this.queryInfo.total }}</span>
        <span v-else style="color:red">{{ this.selectedList.length }}</span> 
        个已开通订单
      </div>
      <div style="text-align: center; padding: 20px 0">请确认是否取消订单</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title=""
        :visible.sync="upgradeGoodsDialogVisible"
        class="formDialog"
        width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        升级商品列表

        <el-popover placement="bottom-start" width="300" trigger="hover">
          <div v-html="bktsjWord" style="white-space: pre-line"></div> 
          <i 
            slot="reference"
            style="margin-left: 5px"
          ><i class="el-icon-question"></i></i>
        </el-popover>
      </div>
      <TableComponents
          :columns="upgradeColumns"
          :tableData="upgradeForm.goods"
      >
        <template slot="operation" slot-scope="{ row }">
          <el-radio v-model="upgradeForm.selectGoods" :label="row">选择</el-radio>
        </template>
      </TableComponents>
      <span v-if="upgradeForm.selectGoods" style="padding-top: 20px; color: red;">已选择升级到{{ upgradeForm.selectGoods.good_name }}，需补差价{{ upgradeForm.selectGoods.diff_price }}元</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upgradeGoodsDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="upgradeLoading" @click="confirmUpgradeFn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title=""
        :visible.sync="upgradeTipsVisible"
        class="formDialog"
        width="600px"
    >
      <div style="text-align: center; padding: 20px 0">开通成功</div>
      <div style="display: flex; flex-direction: column;justify-content: center;align-items: center;">
        <span style="text-align: center;color: red; padding-top: 20px; font-size: 26px;">已扣除差价{{ this.upgradeTips.diff_price }}元</span>
        <span style="text-align: center;font-size: 32px; padding-top: 20px;">已成功升级为{{ this.upgradeTips.good_name }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import financialApi from "@/api/financial.js";
import { clearObj, deepClone } from "@/utils/index.js";
import TableComponents from "@/components/TableComponents.vue";
import qee from "qf-export-excel";
import commonApi from "@/api/common";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "OrderList",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      timeChange: 4,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        pay_status: -1,
        pm_user_id: "",
        order_no: "",
        user_no: "",
        good_type: "",
        good_name: "",
        created_start_time: "",
        created_end_time: "",
        pay_start_time: "",
        pay_end_time: "",
        card_status: 0,
        // createTime:[]
      },
      // 学员自购订单时才会出现的搜索数据
      queryInfoSelf: {
        income_type: "", // 收益类型
        promoter_fullname: "", // 推广者姓名
      },
      typeOptions: [
        // { value: "", label: "请选择" },
        { value: 3, label: "老师推广" },
        { value: 2, label: "员工推广" },
        { value: 1, label: "自推" },
      ],
      allInfo: {
        pay_count: "",
        pay_fee: "",
        refund_fee: "",
      },
      columns: [
        //列数据
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" },

        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" },

        { label: "开通人（机构账号登录）", prop: "pm_user_id" },
        // {label:'商品类型',prop:'finTransaction'},
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name", isMyself: true },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "订单状态", prop: "payStatus" },
        { label: "支付方式", prop: "cooperation_type" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        { label: "学员所属创建人", prop: "create_user", isMyself: true },
        // { label: "操作", prop: "operation" },
      ],
      selfColumns: [
        //学员自购订单（推广订单）列数据
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" },
        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" },
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name" },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "收益类型", prop: "income_type" },
        { label: "推广者姓名", prop: "promoter_fullname" },
        { label: "推广提成比例", prop: "tc_per" },
        { label: "老师/员工提成", prop: "tc_money" },
        {
          label: "机构收益（销售价-成本价：含提成部分）",
          prop: "group_tc_money",
        },
        { label: "订单状态", prop: "payStatus" },
        { label: "支付方式", prop: "cooperation_type" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        // { label: "操作", prop: "operation" },
      ],
      kamilColumns: [
        //卡密订单
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" },
        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" },
        { label: "开通人（机构账号登录）", prop: "pm_user_id" },
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name", isMyself: true },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "订单状态", prop: "order_status" },
        { label: "支付状态", prop: "pay_type_name" },
        { label: "开卡状态", prop: "card_status_name" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        // { label: "操作", prop: "operation" },
      ],
      upgradeColumns: [
        //列数据
        { label: "商品ID", prop: "tob_good_id" },
        { label: "升级类型", prop: "good_name" },
        { label: "补差价", prop: "diff_price" },
        { label: "选择", prop: "operation" },
      ],
      excelTabelList: [], // 用户excel表格导出用的数据
      tableLoading: false, // 列表加载状态
      nameList: [], // 姓名选择列表 
      tableFunction: {
        checkData: 1, //是否允许勾选 
        name: "dialogGoods",
      },
      tableList: [],
      subject_cate_ids: [],

      columnsCourse: [
        { label: "序号", prop: "serial" },
        { label: "课程名称", prop: "name" },
        { label: "试听", prop: "operation" },
      ],
      tableCourse: [],
      tableFunctionCourse: {
        height: 360,
      },
      // 新增编辑表单数据
      addFormShow: false,
      userShow: false,
      userInfo: {
        qgroup: {
          name,
        },
        remarks: "",
        remarksTuifei: "",
        pay_status: 0,
        is_can_refund: 0,
      },
      rules: {
        line_price: [
          { required: true, message: "请输入划线价格", trigger: "blur" },
        ],
        good_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      userCustomShow: false,
      timeFrame: [],
      userTypeList: [],
      subjectOptions: [],
      orderType: 1, // 订单类型
      downExcelLoading: false, // 下载excel时，按钮的加载状态
      role: "", // 当前角色
      is_study_card: 0,
      payTypeOrderName: "",
      isCanRefundShow: false,
      order_status_list: [],
      card_status_list: [],
      excelVisible: false,
      createUserOptions: [],
      create_user: [],
      can_operate:"",
      can_view_amount:"",
      allStatus: false,
      allStatusText:"选择当前页",
      allSelectedStatus: false,
      selectedList:[],
      allStatusVisible: false,
      selectableShow: false,
      can_operate_show: true,
      upgradeGoodsDialogVisible: false,
      upgradeLoading: false,
      upgradeForm: {
        order_id: '',
        user_id: '',
        goods: [],
        selectGoods: '',
      }, // 要升级的商品数据
      upgradeTipsVisible: false,
      upgradeTips: '',
      bktsjWord:""
    };
  },
  computed: {
    dialogType() {
      return "订单详情";
    },
    isSalespersonr() {
      //  this.$store.state.user.userInfo.role,this.$store.state.user.userInfo.role == 'salespersonr');
      return this.$store.state.user.userInfo.role == "salespersonr";
    },
    typeOptionsMap() {
      return new Map(this.typeOptions.map((item) => [item.value, item.label]));
    },
  },
  watch: {
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.userInfo);
        } else {
          this.isCanRefund();
          this.payTypeOrder();
          console.log("isCanRefund", this.isCanRefund(), this.payTypeOrderName);
        }
      },
    },
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
  },
  created() {
    this.getTobHideMenu();
    this.queryInfo.order_no = this.$route.query.order_no;
    if (this.$route.query.order_type) {
      this.orderType = this.$route.query.order_type;
    }
    if (this.$route.query.realname) {
      // this.create_user = this.$route.query.realname;
      var keywords = this.$route.query.realname
      this.getTobSearchCreateUser(keywords)
      this.create_user.push(keywords)
    }
    this.getDic()
    this.getMe()
    this.getTobOpenExams();
    this.getNameList();
    this.queryTable();
  },
  methods: {
    getDic() {
      commonApi.getDictionaries({ names: "bktentitlementpicture" }).then((res) => {
        if (res.data && res.data.bktentitlementpicture.length > 0) {
          res.data.bktentitlementpicture.forEach((item) => {
            if (item.key === "bktsjWord") { 
              this.bktsjWord = item.value;
              console.log("bktsjWord", this.bktsjWord)
            }  
          });
        }  
      })
    },
    detailDialogCancel() {
      this.userCustomShow = false
    },
    // 提交升级
    async confirmUpgradeFn() {
      console.log("this.upgradeForm", this.upgradeForm, this.upgradeForm.selectGoods)
      if(this.upgradeForm.selectGoods.length == 0){
        this.$message({
          message: "请选择要升级的商品",
          type: "error",
        });
        return
      } 
      if (this.upgradeLoading) {
        return
      } 
      this.upgradeLoading = true
      const res = await goodsApi.addMemberPower({
        tob_good_id: this.upgradeForm.selectGoods.tob_good_id.toString(),
        member_id: this.upgradeForm.selectGoods.good_id.toString(),
        tob_user_id: this.upgradeForm.user_id.toString(),
        is_upgrade: '1',
        upgrade_order_id: this.upgradeForm.order_id.toString()
      })
      this.upgradeLoading = false
      if (res.code === 200) {
        this.upgradeGoodsDialogVisible = false
        this.upgradeTips = res.data.upgrade
        this.upgradeTipsVisible = true
        setTimeout(() => {
          this.upgradeTipsVisible = false
        }, 2000)
        this.queryTable()
      } else {
        this.$message.error(res.message);
      }
    },
    // 弹出升级订单弹窗
    async upgradeOrder(row) {
      const res = await goodsApi.upgradeGoodsList({ order_id: row.id})
      if (res.code === 200) {
        console.log("upgradeOrder", row, res, this.upgradeForm)
        this.upgradeForm.order_id = row.id
        this.upgradeForm.user_id = row.user_id
        this.upgradeForm.goods = res.data.list
        this.upgradeForm.selectGoods = ''
        this.upgradeGoodsDialogVisible = true
      } else {
        this.$message.error(res.message);
      }
    },
    payStatusChange(e){
      console.log("payStatusChange", e)
      
    },
    confirmFn(){  
        var postData = deepClone(this.queryInfo)
        if(this.allStatus){
          postData.type = 2 
          postData.ids = "" 
        }else{
          if(this.selectedList.length){
            postData.type = 1 
            var ids = []
            this.selectedList.forEach(item=>{
              ids.push(item.id)
            })
            postData.ids = ids.toString()
          }else{
            this.$message.error("请选择要取消的订单！");
          }
        }  
        goodsApi.tobOrderBatch(postData).then((res) => {
          this.allStatusVisible = false  
          if (res.code == 200) {   
            if(res.success){
              const h = this.$createElement;
              this.$message({
                  type: "success",
                  message: h('p', null, [
                    h('span', null, '已成功取消 '),
                    h('i', { style: 'color: red' }, res.success),
                    h('span', null, '个订单 '),
                  ])
              });  
            }
            this.selectableShow = false 
            this.resetQuery() 
          }else{
            this.$message.error(res.message);
          }
        }); 
    },
    cancelOrderFn() {
      if(this.allStatus || this.selectedList.length>0){
        console.log("cancelOrderFn", this.allStatus, this.selectedList)
        this.allStatusVisible = true
      }else{
        this.$message.error("请选择要取消的订单！");
      } 
    },
    choiceGoods(e) { 
      this.selectedList = e;
    },
    allSelected(e) {
      if (e) {
        this.allStatus = false
        this.selectedList = this.tableList
      } else {
        this.selectedList = []
      } 
    },
    allStatusChange(e){ 
      this.$nextTick(() => {
        this.allStatus = e
        this.allSelectedStatus = false
        this.selectedList = []
        if(e){   
          this.allStatusText = '已选所有页'
        } else {
          this.allStatusText = '选择所有页'
        }
      })
      console.log("allStatus",e,this.allStatus)
      this.$forceUpdate()
    },
    // 防抖函数
    debounce(fn, wait) {
      let timeout;
      let _this = this;
      return function (...args) {
        // 清空定时器
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(_this, args);
        }, wait);
      };
    },
    getTobSearchCreateUser(keywords) {
      if (keywords.trim().length != 0) {
        commonApi.getTobSearchCreateUser({ keywords }).then((res) => {
          if (res.code == 200) {
            this.createUserOptions = res.data.list;
          }
        });
      }
    },
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    async downloadOrderList() {
      // 导出
      const foo = this.$createElement;
      this.$confirm("", {
        message: foo("div", null, [
          // 样式1
          foo(
            "p",
            {
              class: "el-confirm-span",
              style:
                "margin: 10px 0;font-size: 15px;font-weight: bold;color: #191B27;",
            },
            "提示"
          ),
          // 样式2
          foo("i", {
            class: "el-icon-question",
            style:
              "color: rgb(255, 153, 0); font-size: 20px; vertical-align: middle; margin-top: -3px; margin-right: 5px;",
          }),
          foo(
            "span",
            {
              style:
                "margin: 10px 0;color: rgb(25, 27, 39);font-size: 15px;font-weight: bold;",
            },
            "是否确认导出订单列表?"
          ),
          // 样式3
          foo(
            "p",
            { style: "margin:10px 15px;color: #191B27;" },
            "（可按筛选条件导出指定订单列表）"
          ),
        ]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "demo2",
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(() => {
          this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
          let query = deepClone(this.queryInfo);
          query.limit = 100000;
          query.order_type = this.orderType;
          if (this.orderType == 2) {
            query = { ...query, ...this.queryInfoSelf };
            delete query.pm_user_id;
          }

          if (this.orderType == 1 && this.create_user.length > 0) {
            query.create_user = this.create_user.join(",");
          }

          financialApi.orderList(query).then((res) => {
            if (res.code === 200) {
              this.excelVisible = true;
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    payTypeOrder() {
      let _payStatus = ""; 
      if(this.userInfo.is_can_refund == 1){
        _payStatus = this.userInfo.can_refund_button_text
      }else if(this.userInfo.is_can_cancel == 1){
        _payStatus = this.userInfo.can_cancel_button_text
      }else{
        _payStatus = this.userInfo.default_button_text
      }  
      this.payTypeOrderName = _payStatus;
      console.log("this.payTypeOrderName", this.payTypeOrderName);
    },
    // 取消订单 ｜｜ 退费申请
    async cancelOper() {
      if(this.isCanRefundShow){  
        if (this.orderType == 2) {
          if (this.userInfo.is_can_refund == 1 && !this.userInfo.tobrefund) {
            this.userCustomShow = true;
          } else if (
            this.userInfo.is_can_refund == 1 &&
            this.userInfo.tobrefund
          ) {
            // 0待审核 1已通过 2未通过
            if (this.userInfo.tobrefund.status == 2) {
              //退款申请按钮
              this.userCustomShow = true;
            } else {
              return;
            }
          } else {
            return;
          }
        } else if (this.orderType == 3) {
          if (this.userInfo.is_can_refund == 1) {
            //退款申请按钮
            this.userCustomShow = true;
          }
          if (this.userInfo.is_can_cancel == 1) {
            let _obj = {
              id: this.userInfo.id,
              remarks: this.userInfo.remarks,
              type: 3,
            };
            const res = await financialApi.cancelOrder(_obj);
            if (res.code == 200) {
              this.addFormShow = false;
              this.$message.success(res.message);
              this.queryTable();
            } else {
              this.$message.error(res.message);
            }
          }
        } else {
          if (
            this.userInfo.pay_status == 2 ||
            this.userInfo.pay_status == 3 ||
            this.userInfo.pay_status == 4
          ) {
            return;
          }
          if (this.userInfo.pay_at) {
            // 升级订单直接就提示不能退费
            if (this.userInfo.is_upgrade == 1) {
              this.$message.error('该订单已升级，暂不支持退费申请！');
              return
            }
            this.userCustomShow = true;
          } else {
            let _obj = {
              id: this.userInfo.id,
              remarks: this.userInfo.remarks,
              type: 1,
            };
            if (!this.userInfo.pay_at) {
              //取消订单
              _obj.status = 2;
            }
            const res = await financialApi.cancelOrder(_obj);
            if (res.code == 200) {
              this.addFormShow = false;
              this.queryTable();
            } else {
              this.$message.error(res.message);
            }
          }
        } 
      }
    },
    isCanRefund() {
      console.log("111", this.orderType); 
        if (this.userInfo.is_can_refund == 1 || this.userInfo.is_can_cancel == 1 ) {
          this.isCanRefundShow = true;
        } else {
          this.isCanRefundShow = false;
        }  
    },
    getTobHideMenu() {
      goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          this.is_study_card = res.data.is_study_card;
          console.log("is_study_card", res.data.is_study_card);
        }
      });
    },
    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        console.log("getTobOpenExams---", res.data);
        this.subject_cate_ids = [];
        this.subjectOptions = res.data.subject_cate_list;
        res.data.subject_cate_list.forEach((item) => {
          this.subject_cate_ids.push(item.key);
        });
      }
    },
    // 订单类型改变
    orderTypeChange() {
      console.log("改变", this.orderType);

      this.allStatus = false
      this.allSelectedStatus = false
      this.selectedList = []
      // 类型切换就重置请求参数
      this.resetQuery();
      // this.queryTable();
    },
    // 获取当前用户身份
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.role = res.data.role;

        
        if(this.role == 'nstitutionalteacher'||this.role == 'salespersonr'){ 
          this.columns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.columns.splice(index, 1)
            }
            if(item.prop=="fees"){
              this.columns.splice(index, 1) 
            } 
          })
        }
        console.log("角色", this.role);
      }
    },
    // 列表数据
    async queryTable(_type) {

      if(this.queryInfo.pay_status==0){
        this.selectableShow = true
      }else{
        this.selectableShow = false 
      }

      if (_type) {
        this.queryInfo.page = 1;
      }
      this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
      let query = deepClone(this.queryInfo);
      query.order_type = this.orderType;

      console.log("create_user", this.orderType, this.create_user);
      if (this.orderType == 1 && this.create_user.length > 0) {
        query.create_user = this.create_user.join(",");
      }

      if (this.orderType == 2) {
        query = { ...query, ...this.queryInfoSelf };
        delete query.pm_user_id;
      }
      this.tableLoading = true;
      const res = await financialApi.orderList(query);
      //  res);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        this.tableList = res.data.list.data;
        this.allInfo = res.data;
        this.userTypeList = Object.keys(res.data.use_type_list).map(
          (item, index, val) => {
            console.log("item", item);
            return {
              name: res.data.use_type_list[item],
              value: item,
            };
          }
        );
        console.log("this.userTypeList---", this.userTypeList);
        this.tableList.forEach((item, index) => {
          this.tableList[index].finType = item.type == 1 ? "支出" : "收入";
          let _noti = "";
          switch (item.good_type) {
            case 3:
              _noti = "做题会员卡";
              break;
            case 4:
              _noti = "购买课程";
              break;
            case 6:
              _noti = "学籍卡类型";
              break;
            case 10:
              _noti = "vip学员";
              break;
            case 11:
              _noti = "svip学员卡";
              break;
          }

          let _payStatus = ""; 
          if (item.is_study_card != 1) {
            _payStatus = item.order_status
            // switch (item.pay_status) {
            //   case 0:
            //     _payStatus = "已开通";
            //     break;
            //   case 1:
            //     _payStatus = "已扣款";
            //     break;
            //   case 2:
            //     _payStatus = "已取消";
            //     break;
            //   case 3:
            //     _payStatus = "已退款";
            //     break;
            //   case 4:
            //     _payStatus = "已扣款"; //退款中
            //     break;
            //   case 5:
            //     _payStatus = "已扣款"; //退款失败
            //     break;
            //   case 6:
            //     _payStatus = "未支付";
            //     break;
            //   case 7:
            //     _payStatus = "已支付";
            //     break;
            // }
          } else {
            _payStatus = item.study_card_pay_status_name;
          }

          if (this.orderType == 2) {
            let _income_type = "";
            switch (item.income_type) {
              case 3:
                _income_type = "老师推广";
                break;
              case 2:
                _income_type = "员工推广";
                break;
              case 1:
                _income_type = "自推";
                break;
            }
            // 如果是自推
            if (item.income_type == 1) {
              this.tableList[index].tc_per = "-";
              this.tableList[index].tc_money = "-";
            } else {
              this.tableList[index].tc_per = item.tc_per + "%*销售价";
            }
            this.tableList[index].income_type = _income_type;
          }
          this.tableList[index].payStatus = _payStatus;
          this.tableList[index].fees = this.tableList[index].fee;
          this.tableList[index].finTransaction = _noti;
        });
        this.tableLoading = false;

        this.order_status_list = res.data.order_status_list;
        this.card_status_list = res.data.card_status_list;
 
        if (res.data.can_operate && this.can_operate_show) { 
          this.columns.push({ label: "操作", prop: "operation" })
          this.selfColumns.push({ label: "操作", prop: "operation" })
          this.kamilColumns.push({ label: "操作", prop: "operation" })
          this.can_operate_show = false
        }
        if(!res.data.can_view_amount){
          this.columns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.columns.splice(index, 1)
            }
            if(item.prop=="fees"){
              this.columns.splice(index, 1) 
            }
          })
          this.selfColumns.forEach((item, index) => { 
            if(item.prop=="fee"){
              this.selfColumns.splice(index, 1)  
            }
            if(item.prop=="fees"){
              this.selfColumns.splice(index, 1)   
            }
          })
          this.kamilColumns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.kamilColumns.splice(index, 1)  
            }
            if(item.prop=="fees"){
              this.kamilColumns.splice(index, 1)   
            } 
          }) 
        } 
        this.can_operate = res.data.can_operate;
        this.can_view_amount = res.data.can_view_amount;  
 
        if(res.data.subject_cate_list.length < 2){
          if(this.orderType == 1){ 
            this.columns.forEach((item,index) => {
              if(item.prop == 'subject_cate_name'){
                this.columns.splice(index, 1)
              }
            })
          }else if(this.orderType == 2){
            this.selfColumns.forEach((item,index) => {
              if(item.prop == 'subject_cate_name'){
                this.selfColumns.splice(index, 1)
              }
            }) 
          }else if(this.orderType == 3){ 
            this.kamilColumns.forEach((item,index) => {
              if(item.prop == 'subject_cate_name'){
                this.kamilColumns.splice(index, 1)
              }
            }) 
          } 
        }   
      }
    },
    // 姓名列表
    getNameList() {
      financialApi.getExtendNameList().then((res) => {
        if (res.code == 200) {
          console.log("姓名列表", res.data.data);
          const resObj = res.data.data;
          for (const item in resObj) {
            // console.log('单个', resObj[item])
            this.nameList.push({ value: resObj[item] });
          }
          // this.nameList = res.data.data.map((item) => {
          //   return { value: item };
          // });
        }
      });
    },
    // 姓名查询选项获取函数
    querySearch(queryString, cb) {
      cb(this.nameList);
    },
    // 姓名选择函数
    handleNameSelect(item) {
      console.log("选择姓名", item);
      this.queryInfoSelf.promoter_fullname = item.value;
    },
    // 导出Excel
    async downloadExcel() {
      // 标题的数据来源
      const titleList = [];
      this.downExcelLoading = true;
      this.selfColumns.forEach((item) => {
        if (item.prop != "operation") {
          titleList.push({
            title: item.label,
            key: item.prop,
          });
        }
      });
      console.log("队列", titleList);

      this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
      let query = deepClone(this.queryInfo);
      query.order_type = this.orderType;
      if (this.orderType == 2) {
        query = { ...query, ...this.queryInfoSelf };
        delete query.pm_user_id;
      }
      query.limit = 100000;
      const res = await financialApi.orderList(query);
      this.downExcelLoading = false;
      //  res);
      if (res.code == 200) {
        // this.queryInfo.total = res.data.list.total;
        this.excelTabelList = res.data.list.data;
        this.userTypeList = Object.keys(res.data.use_type_list).map(
          (item, index, val) => {
            console.log("item", item);
            return {
              name: res.data.use_type_list[item],
              value: item,
            };
          }
        );
        console.log("this.userTypeList---", this.userTypeList);
        this.excelTabelList.forEach((item, index) => {
          this.excelTabelList[index].finType = item.type == 1 ? "支出" : "收入";
          let _noti = "";
          switch (item.good_type) {
            case 3:
              _noti = "做题会员卡";
              break;
            case 4:
              _noti = "购买课程";
              break;
            case 6:
              _noti = "学籍卡类型";
              break;
            case 10:
              _noti = "vip学员";
              break;
            case 11:
              _noti = "svip学员卡";
              break;
          }
          let _payStatus = "";
          switch (item.pay_status) {
            case 0:
              _payStatus = "已开通";
              break;
            case 1:
              _payStatus = "已扣款";
              break;
            case 2:
              _payStatus = "已取消";
              break;
            case 3:
              _payStatus = "已退款";
              break;
            case 4:
              _payStatus = "已扣款"; //退款中
              break;
            case 5:
              _payStatus = "已扣款"; //退款失败
              break;
            case 6:
              _payStatus = "未支付";
              break;
            case 7:
              _payStatus = "已支付";
              break;
          }
          if (this.orderType == 2) {
            let _income_type = "";
            switch (item.income_type) {
              case 3:
                _income_type = "老师推广";
                break;
              case 2:
                _income_type = "员工推广";
                break;
              case 1:
                _income_type = "自推";
                break;
            }
            switch (item.income_type) {
              case 3:
                _income_type = "老师推广";
                break;
              case 2:
                _income_type = "员工推广";
                break;
              case 1:
                _income_type = "自推";
                break;
            }
            // this.excelTabelList[index].income_type = _income_type;
            // if(item.tc_per) {
            //   this.excelTabelList[index].tc_per = item.tc_per + '%*销售价'
            // }
            // 如果是自推
            if (item.income_type == 1) {
              this.excelTabelList[index].tc_per = "-";
              this.excelTabelList[index].tc_money = "-";
            } else {
              this.excelTabelList[index].tc_per = item.tc_per + "%*销售价";
            }
            this.excelTabelList[index].income_type = _income_type;
          }
          this.excelTabelList[index].payStatus = _payStatus;
          this.excelTabelList[index].fees = this.excelTabelList[index].fee;
          this.excelTabelList[index].finTransaction = _noti;
        });
      }

      console.log("表数据", this.excelTabelList[0]);
      const randomStr = this.generate();
      const fileName = "学员自购订单（推广订单）" + randomStr;
      console.log("文件名", fileName);
      qee(titleList, this.excelTabelList, fileName);
    },
    // 生成随机数
    generate() {
      let timeStr = new Date().valueOf() + "";
      let randomStr = Math.random() + "";
      return timeStr.slice(2, 8) + randomStr.slice(2, 8);
    },
    // 打开弹窗
    async viewDetail(row, _type) {
      console.log("viewDetail", row);
      this.userShow = _type;
      Object.assign(this.userInfo, row);
      //  this.userInfo);
      // const res = await goodsApi.courseDetail({id:row.id})
      // if(res.code == 200){
      this.addFormShow = true;
      //   this.userInfo = res.data
      //   this.userInfo.cover_small = row.cover_small
      //   this.userInfo.price = row.price
      //   this.userInfo.id = row.id
      //   this.tableCourse = this.userInfo.data[0].son_chapter_list
      //    'this.userInfo',this.userInfo);
      // }
    },

    async addUser() {
      //  this.userInfo);
      let _obj = {
        id: this.userInfo.id,
        remarks: this.userInfo.remarks,
        type: 0,
      };
      const res = await financialApi.cancelOrder(_obj);
      if (res.code == 200) {
        this.addFormShow = false;
        this.queryTable();
      } else {
        this.$message.error(res.message);
      }
    },
    // 提交退费申请
    async tuifeiAdd() {
      if (!this.userInfo.is_can_refund) {
        this.$message.error("已过退费时效");
        return
      }
      //  this.userInfo);
      let _obj = {
        id: this.userInfo.id,
        remarks: this.userInfo.remarksTuifei,
      };
      const res = await financialApi.refundOrder(_obj);
      if (res.code == 200) {
        this.addFormShow = false;
        this.userCustomShow = false;
        this.queryTable();
      } else {
        this.$message.error(res.message);
      }
    },
    // // 添加｜｜修改数据
    // addUser(formName){
    //   this.$refs[formName].validate(async (valid) => {
    //     if (valid) {
    //       let _obj = {
    //         type:1,
    //         price:~~this.userInfo.good_price,
    //         line_price:~~this.userInfo.line_price,
    //         relation_id:this.userInfo.id
    //       }
    //        '_____obj____',_obj);
    //       const res = await goodsApi.updateGoodsPrice(_obj)
    //       if(res.code==200){
    //         this.$message.success("修改成功!")
    //         this.addFormShow = false
    //         this.queryTable()
    //       }
    //     } else {
    //        'error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // // 删除数据
    // deleteData(row){
    //   this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    // editCode(formName){
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert('修改成功!');
    //       this.resetCodeShow = false
    //     } else {
    //        'error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.allSelectedStatus = false
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.create_user = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        pay_status: -1,
        pm_user_id: "",
        order_no: "",
        user_no: "",
        good_type: "",
        good_name: "",
        created_start_time: "",
        created_end_time: "",
        pay_start_time: "",
        pay_end_time: "",
        card_status: 0,
        // createTime:[]
      };
      this.queryInfoSelf = {
        income_type: "", // 收益类型
        promoter_fullname: "", // 推广者姓名
      };
      this.subject_cate_ids = [];
      this.subjectOptions.forEach((item) => {
        this.subject_cate_ids.push(item.key);
      });
      this.queryTable();
    },

    // 日期查询
    selectData(e) {
      if (e) {
        if (this.timeChange == 4) {
          this.queryInfo.pay_start_time = e[0];
          this.queryInfo.pay_end_time = e[1];
          this.queryInfo.created_start_time = "";
          this.queryInfo.created_end_time = "";
        } else {
          this.queryInfo.pay_start_time = "";
          this.queryInfo.pay_end_time = "";
          this.queryInfo.created_start_time = e[0];
          this.queryInfo.created_end_time = e[1];
        }
      } else {
        this.queryInfo.pay_start_time = "";
        this.queryInfo.pay_end_time = "";
        this.queryInfo.created_start_time = "";
        this.queryInfo.created_end_time = "";
      }
    },
    // 跳转
    skipToTuikuan() {
      this.$router.push({
        path: "/refundApplication",
        query: {
          order: this.userInfo.order_no,
        },
      });
    },
    timeChangeClick() {
      this.timeFrame = [];
      this.queryInfo.pay_start_time = "";
      this.queryInfo.pay_end_time = "";
      this.queryInfo.created_start_time = "";
      this.queryInfo.created_end_time = "";
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }

  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;

      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }

      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }

    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }

  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }

  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }

      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          border-radius: 10px;
        }
      }
    }

    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;

      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }

      .t2 {
      }

      .t3 {
      }
    }

    .el-select .el-input {
      width: 180px;
    }

    .el-input {
      width: 250px;
    }

    .dialog-footer {
      text-align: center;
    }

    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;

        .el-form-item__content {
          margin-left: 0 !important;
        }

        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }

        .el-button {
          border: none;
          padding-left: 5px;
        }

        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

h5 {
  text-align: right;
  margin-right: 20px; 

  //span {
    //color: red;
  //}
}

// 步骤条

.orderD {
  display: flex;
  margin-bottom: 15px;
  line-height: 40px;

  span {
    display: inline-block;
    width: 100px;
    text-align: center;
  }

  div {
    flex: 1;
    background-color: rgb(222, 222, 222);
    border-radius: 10px;
    color: #000;
    text-align: center;
  }
}

.order-type-box {
  margin-bottom: 10px;

  .order-type-item {
    width: 200px;
  }

  /deep/ .el-radio-button__inner {
    width: 100%;
  }
}
.order-type-box {
  margin: 15px;
}
.search-btn-box {
  margin-bottom: 12px;
} 
</style>
